import { render, staticRenderFns } from "./TutuInventoryPrint.vue?vue&type=template&id=ecf62b18&scoped=true"
import script from "./TutuInventoryPrint.vue?vue&type=script&lang=js"
export * from "./TutuInventoryPrint.vue?vue&type=script&lang=js"
import style0 from "./TutuInventoryPrint.vue?vue&type=style&index=0&id=ecf62b18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf62b18",
  null
  
)

export default component.exports